<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">Change Password</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="text-center">
        <p>
          Weak passwords can easily lead to unauthorised access of your account
          and loss of funds
        </p>
      </div>

      <div class="panel panel-filled">
        <div class="panel-body">
          <form @submit.prevent="updatePassword">
            <div class="form-group">
              <label for="oldPassword">Current Password</label>
              <input
                id="oldPassword"
                type="password"
                v-model="oldPassword"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="newPassword">New Password</label>
              <vue-password
                id="newPassword"
                v-model="newPassword"
                classes="form-control"
              >
              </vue-password>
            </div>
            <div class="form-group">
              <label for="repeatPassword">Confirm Password</label>
              <vue-password
                id="repeatPassword"
                v-model="repeatPassword"
                classes="form-control"
              >
              </vue-password>
            </div>
            <button
              v-if="loading"
              class="btn btn-default btn-block"
              disabled=" "
            >
              <i class="fad fa-spinner-third fa-spin m-r-xs"></i>Loading
            </button>

            <button
              v-else-if="!oldPassword || !newPassword || !repeatPassword"
              class="btn btn-default btn-block"
              disabled=" "
            >
              Change
            </button>
            <button v-else class="btn btn-accent btn-block text-accent">
              Change
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeToast from "native-toast";
import auth from "@/api/auth";
import VuePassword from "@/components/VuePassword";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      repeatPassword: null,
      loading: false
    };
  },
  components: {
    VuePassword
  },
  mounted() {},
  methods: {
    ...mapActions(["setToken"]),
    async updatePassword() {
      this.loading = true;
      if (this.newPassword == this.repeatPassword) {
        await auth
          .updatePassword({
            old_password: this.oldPassword,
            new_password: this.newPassword,
            same_password: this.repeatPassword
          })
          .then(response => {
            this.loading = false;
            this.setToken(response.data.token);

            this.oldPassword = null;
            this.newPassword = null;
            this.repeatPassword = null;
            nativeToast({
              message: "Password has changed.",
              position: "top",
              timeout: 3000,
              type: "success"
            });
          })
          .catch(error => {
            this.loading = false;
            nativeToast({
              message: error.response.data.error,
              position: "top",
              timeout: 3000,
              type: "error"
            });
          });
      } else {
        this.loading = false;
        nativeToast({
          message: "confirm password is not match",
          position: "top",
          timeout: 3000,
          type: "error"
        });
      }
    }
  }
};
</script>
